import { Action } from 'redux-actions'
import { SagaIterator } from 'redux-saga'
import { put, takeLatest, all, select } from 'redux-saga/effects'

import { getCurrentUserId } from '@tabeeb/modules/account/selectors'
import { onAddErrorNotification, onAddInfoNotification } from '@tabeeb/modules/notification/actions'

import { signalrEvents, signalrConstants } from '../../signalr'
import { openInfoMessageDialog, triggerFormAction } from '../actions'

function* onFormActionSuccess() {
  yield put(onAddInfoNotification({ message: 'Form action was triggered' }))
}

function* onFormActionFailed() {
  yield put(onAddErrorNotification({ message: 'Failed to trigger form action' }))
}

function* onShowInfoMessage(
  action: Action<[{ infoMessage: { id: string; message: string }; userId: number }]>
): SagaIterator {
  const [{ infoMessage, userId }] = action.payload
  const currentUserId: ReturnType<typeof getCurrentUserId> = yield select(getCurrentUserId)

  if (currentUserId === userId) {
    yield put(openInfoMessageDialog(infoMessage))
  }
}

function* formActions() {
  yield all([
    takeLatest(triggerFormAction.success, onFormActionSuccess),
    takeLatest(triggerFormAction.failed, onFormActionFailed),
    takeLatest(signalrEvents[signalrConstants.tabeebHubName].onShowInfoMessage, onShowInfoMessage),
  ])
}

export default formActions
